import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
      <h1 className="text-9xl font-bold text-blue-600">404</h1>
      <div className="absolute rotate-12 rounded bg-blue-100 px-2 text-sm text-blue-800">
        Page Not Found
      </div>
      <div className="mt-5">
        <h3 className="text-2xl font-semibold text-gray-800 md:text-3xl">
          Oops! We can't find that page.
        </h3>
        <p className="mt-4 text-gray-600">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-8 space-y-2">
          <Link
            to="/"
            className="inline-block rounded bg-blue-600 px-5 py-3 text-sm font-medium text-white hover:bg-blue-700"
          >
            Go back home
          </Link>
          <p className="mt-4 text-sm text-gray-500">
            If you think this is a mistake, please{' '}
            <a href="mailto:support@college.edu" className="text-blue-600 hover:underline">
              contact support
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
